import {removeSessionData, removeUserLoggingOut, setUserLoggingOut} from "./sessionUtil";
import {SignoutOptions} from "@okta/okta-auth-js/types/lib/oidc/types/api";
import {AuthApi} from "../api/AuthApi";
import {getOktaAuth} from "./oktaAuthCreator";

export const triggerOktaLogin =  async (originalUri: string | undefined = undefined) => {
    const oktaAuth = getOktaAuth();
    if (originalUri) {
        oktaAuth.setOriginalUri(originalUri);
    }

    // console.error("=============> Removing session in triggerOktaLogin");
    removeSessionData();
    removeUserLoggingOut();
    await oktaAuth.signInWithRedirect()
        .catch((error) => console.error("=============> oktaAuth.signInWithRedirect in error: ", error));
};

export const oktaSignOut = async (opts?: SignoutOptions) => {
    const oktaAuth = getOktaAuth();
    setUserLoggingOut();
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    await AuthApi.logout().catch((err) => {console.error("=============> AuthApi.logout error: ", err);});
    // console.error("=============>before signed out");
    // await oktaAuth.revokeAccessToken();
    //     .catch((err) => console.error("=============> oktaAuth.revokeAccessToken error: ", err));
    await oktaAuth.signOut(opts)
        .catch((err) => console.error("=============> oktaAuth.signOut error: ", err));
    removeSessionData();
    removeUserLoggingOut();
};
